import { defineType } from 'sanity';

/**
 * SEO section schema for Sanity
 * This aligns with the SeoMetadata type in the template project
 */
export const seo = defineType({
    name: 'seo',
    title: 'SEO Settings',
    type: 'object',
    fields: [
        {
            name: 'title',
            title: 'Title',
            type: 'object',
            description: 'SEO title that appears in search results and browser tabs (keep under 60 characters)',
            fields: [
                { name: 'en', type: 'string', title: 'English' },
                { name: 'sr', type: 'string', title: 'Serbian' },
            ],
            validation: (Rule) => Rule.required().warning('Adding a title is strongly recommended for SEO'),
        },
        {
            name: 'description',
            title: 'Description',
            type: 'object',
            description: 'SEO description that appears in search results (keep under 160 characters)',
            fields: [
                { name: 'en', type: 'text', title: 'English', rows: 3 },
                { name: 'sr', type: 'text', title: 'Serbian', rows: 3 },
            ],
            validation: (Rule) => Rule.required().warning('Adding a description is strongly recommended for SEO'),
        },
        {
            name: 'ogImage',
            title: 'Social Media Image',
            type: 'image',
            description: 'Image that appears when sharing on social media (recommended size: 1200x630)',
            options: {
                hotspot: true,
            },
            fields: [
                {
                    name: 'alt',
                    title: 'Alternative text',
                    type: 'object',
                    description: 'Important for SEO and accessibility',
                    fields: [
                        { name: 'en', type: 'string', title: 'English' },
                        { name: 'sr', type: 'string', title: 'Serbian' },
                    ],
                },
            ],
        },
        {
            name: 'noIndex',
            title: 'Hide from search engines',
            type: 'boolean',
            description: 'Enable this to prevent this page from appearing in search results',
            initialValue: false,
        },
        {
            name: 'structuredData',
            title: 'Structured Data (JSON-LD)',
            type: 'text',
            description: 'Advanced: Add structured data in JSON-LD format for rich results in search engines',
            rows: 10,
        },
    ],
    preview: {
        select: {
            title: 'title.en',
        },
        prepare({ title }) {
            return {
                title: title || 'SEO Settings',
            };
        },
    },
});
